import React from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

/** Standard form label with optional required asterisk. */
const FormField: React.FC<FormFieldProps> = ({ label, required, hint, error, children, className = '' }) => (
  <label className={`block text-sm font-medium text-content ${className}`}>
    <span className="flex items-center gap-1 mb-1.5">
      {label}
      {required && <span className="text-red-500" title="Required">*</span>}
    </span>
    {children}
    {hint && !error && <p className="text-xs text-content-muted mt-1">{hint}</p>}
    {error && <p className="text-xs text-red-600 mt-1" role="alert">{error}</p>}
  </label>
);

export default FormField;

/** Validate required string fields; returns first error message or null. */
export function validateRequired(fields: Record<string, string>, labels: Record<string, string>): string | null {
  for (const [key, label] of Object.entries(labels)) {
    if (!fields[key]?.trim()) return `${label} is required`;
  }
  return null;
}

export const REQUIRED_MARK = <span className="text-red-500 ml-0.5">*</span>;
